"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var Input_styles_1 = __importDefault(require("./Input.styles"));
function Input(_a) {
    var _b, _c;
    var _d = _a.component, Element = _d === void 0 ? 'input' : _d, className = _a.className, _e = _a.invalid, invalid = _e === void 0 ? false : _e, _f = _a.required, required = _f === void 0 ? false : _f, _g = _a.variant, variant = _g === void 0 ? 'default' : _g, icon = _a.icon, style = _a.style, _h = _a.rightSectionWidth, rightSectionWidth = _h === void 0 ? 36 : _h, rightSection = _a.rightSection, _j = _a.rightSectionProps, rightSectionProps = _j === void 0 ? {} : _j, _k = _a.radius, radius = _k === void 0 ? 'sm' : _k, inputClassName = _a.inputClassName, inputStyle = _a.inputStyle, themeOverride = _a.themeOverride, wrapperProps = _a.wrapperProps, elementRef = _a.elementRef, others = __rest(_a, ["component", "className", "invalid", "required", "variant", "icon", "style", "rightSectionWidth", "rightSection", "rightSectionProps", "radius", "inputClassName", "inputStyle", "themeOverride", "wrapperProps", "elementRef"]);
    var theme = theme_1.useMantineTheme(themeOverride);
    var classes = Input_styles_1.default({ radius: radius, theme: theme });
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.inputWrapper, (_b = {}, _b[classes.invalid] = invalid, _b), classes[variant + "Variant"], className), style: style }, wrapperProps),
        icon && (react_1.default.createElement("div", { "data-mantine-icon": true, className: classes.icon }, icon)),
        react_1.default.createElement(Element, __assign({}, others, { "data-mantine-input": true, ref: elementRef, "aria-required": required, "aria-invalid": invalid, className: clsx_1.default((_c = {}, _c[classes.withIcon] = icon, _c), classes.input, inputClassName), style: __assign({ paddingRight: rightSection ? rightSectionWidth : theme.spacing.md }, inputStyle) })),
        rightSection && (react_1.default.createElement("div", __assign({}, rightSectionProps, { "data-mantine-input-section": true, style: __assign(__assign({}, rightSectionProps.style), { width: rightSectionWidth }), className: clsx_1.default(classes.rightSection, rightSectionProps.className) }), rightSection))));
}
exports.Input = Input;
Input.displayName = '@mantine/core/Input';
